import React, { useState, useEffect } from "react";
import { Page, Icon, Link, Button, f7 } from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";

const CanOrderDetailsPage = ({ f7route }) => {
  const { id } = f7route.params;
  const [data, setEventDetails] = useState([]);
  const [cancel, setCancelData] = useState({});

  useEffect(() => {
    // eventbycust/id/+ localStorage.getItem('id') +/?event_id=188
    axios
      .get(API_BASE_URL + "orderscanlist", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          id: id,
          cust_id: localStorage.getItem("id"),
        },
      })
      .then((response) => {
        setEventDetails(response.data.data);
      })

      .catch((error) => console.log(error));
  }, [id]);
  console.log(data);

  useEffect(() => {
    console.log(data);
    setCancelData({
      cust_id: localStorage.getItem("id"),
    });
  }, [data]);

  const bidCancelled = () => {
    axios
      .put(API_BASE_URL + "canclevntbycust/id/" + id, cancel, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        f7.toast
          .create({
            text: "Event Cancelled ..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 2000,
          })
          .open();
      })
      .catch((error) => f7.dialog.alert("Error updating data!"));
  };
  // export default function EventDetailPage() {
  return (
    <Page className="bg-white">
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="custom-container p-0">
              <div className="header-panel">
                <Link href="#" back reloadAll>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Event Details</h2>
                {/* <Link href="#"><Icon ios="material:edit" aurora="material:edit" md="material:edit" className='theme-dark'></Icon></Link> */}
              </div>
            </div>
          </header>
          {data.map((item) => (
            <section className="profile-form mt-3">
              <div className="custom-container p-0">
                <div class="title">
                  <h5 className="fw-bold dark-text dark-text">
                    <span className="light-text">Event ID : </span>{" "}
                    {item.event_id}
                  </h5>
                  <a href="#" className="text-muted text-1">
                    {item.bid_start_date}
                  </a>
                </div>
                <div className="apply-coupon mt-3">
                  <h5>
                    Status:{" "}
                    <span className="text-danger">{item.order_status}</span>
                  </h5>
                </div>
                <table className="table 1table-borderless mt-2 text-2">
                  <tbody>
                    <tr>
                      <td width={"40%"}>Event Name: </td>
                      <td>
                        <b>{item.event_name}</b>
                      </td>
                    </tr>
                    <tr>
                      <td width={"40%"}>Event Date & Time: </td>
                      <td>
                        {item.event_date}, {item.event_by_time}
                      </td>
                    </tr>
                    <tr>
                      <td>Event Size: </td>
                      <td>
                        {item.event_adult_size !== null &&
                          item.event_adult_size !== undefined && (
                            <span>
                              Adults - <strong>{item.event_adult_size}</strong>
                            </span>
                          )}
                        {item.event_kids_size !== null &&
                          item.event_kids_size !== undefined && (
                            <span>
                              , Kids - <strong>{item.event_kids_size}</strong>
                            </span>
                          )}
                      </td>
                    </tr>
                    {/* <tr>
                    <td>Food Need By Time: </td>
                    <td>12: 30pm</td>
                  </tr> */}
                    <tr>
                      <td>Event Address: </td>
                      <td>
                        {item.add_lin_1} {item.add_lin_2} {item.city}{" "}
                        {item.state} {item.zip_code}
                      </td>
                    </tr>
                    <tr>
                      <td>Event Notes: </td>
                      <td>{item.event_note}</td>
                    </tr>
                    <tr>
                      <td>Reason For Cancel: </td>
                      <td>{item?.reason}</td>
                    </tr>
                  </tbody>
                </table>

                {/* <h3 className="fw-bold dark-text mb-2">Restaurant Information</h3> */}
                {/* <div className="vertical-product-box">
                <div className="vertical-box-img p-2" style={{width: '15%'}}>
                  <img alt="" slot="media" src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg" width="40" className="rounded-circle" />
                </div>
                <div className="vertical-box-details">
                  <div className="vertical-box-head">
                    <div className="restaurant">
                      <h5 className="dark-text">Ben &amp; Floren</h5>
                    </div>
                    <h6 className="food-items mb-2" style={{overflow: 'visible'}}><Icon ios="material:location_on" aurora="material:location_on" md="material:location_on" className='text-success text-3'/> 8642 Yule Street, Arvada CO 80007</h6>                    
                  </div>              
                </div>
              </div> */}
              </div>
              <div className="custom-container p-0">
                {item.event_item.length > 0 ? (
                  <h3 className="fw-bold dark-text">Menu Items</h3>
                ) : (
                  " "
                )}
                <table className="table table-striped table-sm text-2 mt-2">
                  <tbody>
                    {item.event_item.length > 0
                      ? item.event_item.map((items, index) => (
                          <tr>
                            <td width={"10%"} className="text-center">
                              {index + 1}.{" "}
                            </td>
                            <td>
                              <h5 className="dark-text fw-bold mb-1">
                                {items.menu_name}
                              </h5>
                              {items.note}
                            </td>
                          </tr>
                        ))
                      : ""}
                  </tbody>
                </table>
              </div>
              <div className="custom-container p-0">
                {item.item.length > 0 ? (
                  <h3 className="fw-bold dark-text">Restaurant Items </h3>
                ) : (
                  ""
                )}
                <table className="table table-striped table-sm text-2 mt-2">
                  <tbody>
                    {item.item.length > 0
                      ? item.item.map((e_item, index) => (
                          <tr>
                            <td width={"10%"} className="text-center">
                              {index + 1}.{" "}
                            </td>
                            <td>
                              <h5 className="dark-text fw-bold mb-1">
                                {e_item.menu_name}
                              </h5>
                              <span>
                                {" "}
                                Qty :{e_item.qty}, Size :{" "}
                                {e_item.menu_size_name}, Amount : $
                                {e_item.menu_amount},{" "}
                              </span>
                            </td>
                            <td>Restaurant Name : {e_item.rest_name}</td>
                          </tr>
                        ))
                      : ""}
                  </tbody>
                </table>
              </div>
              {/* <div className="custom-container p-0">
                <Button type="submit" className="btn btn-danger w-100 mt-0" onClick={ bidCancelled } large role="button">Cancel Bid</Button>
            </div> */}
            </section>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default CanOrderDetailsPage;
